import React, { useEffect, useState } from 'react';
import './App.scss';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Breadcrumb from './components/Breadcrumb/Breadcrumb';
import VehiclePage from './components-pages/vehicle-page/VehiclePage';
import OperationsPage from './components-pages/operations-page/OperationsPage';
import CONSTANTS from './Constants';
import { Route, Routes, useLocation, Navigate, useParams, useSearchParams } from 'react-router-dom';
import YourQuotePage from './components-pages/YourQuote-page/YourQuotePage';
import YourAppointemetPage from './components-pages/YourAppoinyment-page/YourAppointmentPage';
import YourPersonalInfoPage from './components-pages/YourPersonalInfo-page/YourPersonalInfoPage';
import SummaryPage from './components-pages/Summary-page/SummaryPage';
import ConfiramtionPage from './components-pages/Confirmation-page/ConfirmationPage';
import fetchApiData from './apiHandlers/fetchApiData';
import { useDispatch } from 'react-redux';
import { setDealerDetails } from './redux-files/actions/action';

function App() {
  sessionStorage.setItem("afficherPdvTest", CONSTANTS.SITE_CONFIG.afficherPdvTest);
  sessionStorage.setItem("origine", CONSTANTS.SITE_CONFIG.origine);
  const { pathname, search} = useLocation();
  const [searParam] =  useSearchParams(); 
  const dispatch = useDispatch();

  const checkIncludesIdpv = () => {
    // console.log(searParam.get("idpdv"));
    // if (search.includes("&")) {
    //   return search.split("&").find((e) => e.startsWith("idpdv="));
    // } else if (search.includes("idpdv=")) {
    //   return search;
    // } else return;
    return searParam.get("idpdv");
  };

  // let elementidpdv = checkIncludesIdpv();
  // let indexEqual = elementidpdv && elementidpdv.indexOf("=");
  // let idpdv = elementidpdv && elementidpdv.slice(indexEqual + 1);

   //  API that call the webMethode GetListDealer 
    const loadDealers = (idpdv) => {
      console.log("jj",idpdv);
        const DEALERS_API = new fetchApiData();
        DEALERS_API.getListDealers()
            .then(
                data => {
                  console.log(data);
                   let localDealer = data.d.find((dl) => dl.GeoId == idpdv);
                   console.log( "salam"+localDealer);
                   if(localDealer){
                    dispatch(
                      setDealerDetails({
                        iD: localDealer.DealerId,
                        geoID: localDealer.GeoId,
                        name: localDealer.Name,
                        adress: localDealer.Address,
                        city: localDealer.City,
                        zip: localDealer.ZipCode,
                        LCV: localDealer.LCV,
                        PC: localDealer.PC,
                        listPremiumServices: localDealer.ListeIdSP,
                        position: {
                          lat: Number(localDealer.Latitude),
                          lng: Number(localDealer.Longitude),
                        },
                        SelfReception: localDealer.SelfReception,
                        editDealer: false,
                      })
                    );
                    // setNextPath(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
                   }
                })
            .catch(Error => {
                console.log('Error: ', Error);
            });
    }
  

  useEffect(() => {
    let idpdv =  checkIncludesIdpv();
    console.log("allo", searParam);
    idpdv && loadDealers(idpdv);
  }, [searParam])
  
  return (

    <>
      <Header />
      {CONSTANTS.SITE_ROUTS.CONFIRMATION !== pathname && <Breadcrumb />}
      <Routes>
        {process.env.NODE_ENV === 'development' && <Route
          path='/'
          element={<Navigate to={CONSTANTS.SITE_ROUTS.VEHICLEPAGE} />}
        />}
        <Route
          path='/quoting.aspx'
          element={<Navigate to={CONSTANTS.SITE_ROUTS.VEHICLEPAGE+search} />}
        />
        <Route path={CONSTANTS.SITE_ROUTS.VEHICLEPAGE} element={<VehiclePage />} />
        <Route path={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE} element={<OperationsPage />} />
        <Route path={CONSTANTS.SITE_ROUTS.YOURQUOTEPAGE} element={<YourQuotePage />} />
        <Route path={CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE} element={<YourAppointemetPage />} />
        <Route
          path={`${CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE}/:idQuote/:token`}
          element={<YourAppointemetPage isRdvFormQuotingMail={true} />}
        />
        <Route path={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE} element={<YourPersonalInfoPage />} />
        <Route path={CONSTANTS.SITE_ROUTS.SUMMARYPAGE} element={<SummaryPage />} />
        <Route path={CONSTANTS.SITE_ROUTS.CONFIRMATION} element={<ConfiramtionPage />} />
        <Route path="*" element={<Navigate to={CONSTANTS.SITE_ROUTS.VEHICLEPAGE} />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
